'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _canvasStuff = require('./canvasStuff');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BodyworkController = function () {
  function BodyworkController(vehicleService, $scope) {
    "ngInject";

    var _this = this;

    (0, _classCallCheck3.default)(this, BodyworkController);
    this.vehicleService = vehicleService;
    this.$scope = $scope;

    this.height = 900;
    this.width = 700;

    this.editImage();

    this.$scope.$on('vehicleAppraisal:parentFormConfigured', function () {
      _this.editImage();
    });
  }

  (0, _createClass3.default)(BodyworkController, [{
    key: 'editImage',
    value: function editImage(img) {
      var ctrl = this;

      var height = this.height;
      var width = this.width;
      //var $imgToLoad = $('#appraisalImage');
      //var height = parseInt($imgToLoad.height());
      //var width = parseInt($imgToLoad.width());

      var $divCanvas = $('<div idx="imageHolder" style="width:' + width + 'px;height:' + height + 'px;background: url(\'' + this.vehicleAppraisal.imageUrl + '\'); background-repeat: no-repeat; background-size: 100% 100%;"><canvas width="' + width + '" height="' + height + '" style="opacity: .33;" id="sig-canvas"></canvas></div>');
      $('.appraisal-container').empty().append($divCanvas);
      (0, _canvasStuff.doMagic)(this.saveEdit.bind(this));
    }
  }, {
    key: 'reset',
    value: function reset() {
      (0, _canvasStuff.clearCanvas)();
      this.saveEdit();
    }
  }, {
    key: 'saveEdit',
    value: function saveEdit() {
      var ctrl = this;
      var imgData = (0, _canvasStuff.getCanvasData)();

      this.vehicleService.annotateImage(this.height, this.width, this.vehicleAppraisal.imageBase, imgData).then(function (response) {
        ctrl.vehicleAppraisal.imageUrl = response.data;
      });
    }
  }]);
  return BodyworkController;
}();

exports.default = BodyworkController;


// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleAppraisal/bodywork/bodywork.controller.js